import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import ChinaConsultPopup from '../components/ChinaConsultPopup';
import { supabase } from '../lib/supabase';
import { fetchWithAuthRefresh } from '../lib/supabaseAuthRefresh';
import searchIcon from '../assets/icons8-поиск.svg';
import calendarIcon from '../assets/1776279055.svg';
import clockIcon from '../assets/157349.svg';
import shipIcon from '../assets/2154586.svg';
import filterIcon from '../assets/equalizer_filter_filtering_mixer_sorting_icon_123287.svg';

const Container = styled.section`
  padding: 40px 0 135px;
  position: relative;
  z-index: 2;
  
  @media (max-width: 479px) {
    padding: 20px 0 60px;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

// --- Переработанный блок поиска и фильтров ---
const SearchFilterSection = styled.div`

`;

const SearchBar = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 28px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const SearchInputWrapper = styled.div`
  flex: 1;
  position: relative;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 16px 20px 16px 52px;
  border: 1.5px solid #e8e8e8;
  border-radius: 60px;
  font-size: 16px;
  background: #ffffff;
  transition: all 0.2s;
  color: #111;
  
  &::placeholder {
    color: #999;
    font-weight: 400;
  }
  
  &:focus {
    outline: none;
    border-color: #111;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.05);
  }
`;

const SearchIcon = styled.img`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
  opacity: 0.6;
`;

const FilterToggle = styled.button`
  padding: 16px 28px;
  background: #f5f5f5;
  border: 1.5px solid #e8e8e8;
  border-radius: 60px;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  transition: all 0.2s;
  
  &:hover {
    background: #ebebeb;
    border-color: #ccc;
  }
  
  span {
    font-size: 18px;
  }
`;

const FilterPanel = styled.div`
  margin-top: ${props => props.$isOpen ? '24px' : '0'};
  max-height: ${props => props.$isOpen ? '700px' : '0'};
  opacity: ${props => props.$isOpen ? '1' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
`;

const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 24px;
  
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const FilterGroup = styled.div`
  label {
    display: block;
    font-size: 13px;
    color: #777;
    margin-bottom: 8px;
    font-weight: 500;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }
  
  select, input {
    width: 100%;
    padding: 12px 16px;
    border: 1.5px solid #e8e8e8;
    border-radius: 12px;
    font-size: 15px;
    background: white;
    transition: border-color 0.2s;
    color: #111;
    font-weight: 450;
    
    &:focus {
      outline: none;
      border-color: #111;
    }
    
    &::placeholder {
      color: #aaa;
    }
  }
`;

const FilterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
`;

const ClearButton = styled.button`
  background: transparent;
  border: none;
  color: #999;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 30px;
  transition: all 0.2s;
  
  &:hover {
    background: #f5f5f5;
    color: #666;
  }
`;

const ActiveFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const FilterTag = styled.span`
  background: #f5f5f5;
  padding: 6px 14px;
  border-radius: 30px;
  font-size: 13px;
  color: #444;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e8e8e8;
  
  button {
    background: none;
    border: none;
    color: #999;
    cursor: pointer;
    padding: 0;
    font-size: 16px;
    display: flex;
    align-items: center;
    
    &:hover {
      color: #333;
    }
  }
`;

// --- Кнопка "Показать/Скрыть подробности" ---
// Removed: DetailsToggle (no longer used)

// --- Контейнер для всей дополнительной информации ---
// Removed: AdditionalInfo, InfoBlock, InfoBlockTitle (no longer used)

// --- Карточки круизов ---
const ToursGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 30px;
  
  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const TourCard = styled.div`
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
  border: 1px solid #f0f0f0;
  
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
    border-color: #e0e0e0;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 240px;
  overflow: hidden;
  cursor: pointer;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
  }
  
  &:hover img {
    transform: scale(1.06);
  }
`;

// Removed: Badge (no longer used)

const CardContent = styled.div`
  padding: 24px;
`;

const CardHeader = styled.div`
  margin-bottom: 18px;
`;

const CardTitle = styled.h3`
  font-size: 20px;
  font-weight: 650;
  color: #111;
  margin-bottom: 6px;
  cursor: pointer;
  line-height: 1.3;
  letter-spacing: -0.01em;
  
  &:hover {
    color: #FF5E62;
  }
`;

const CardSubtitle = styled.p`
  font-size: 14px;
  color: #777;
  line-height: 1.4;
`;

// Компактная информационная сетка
const InfoStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  margin-bottom: 20px;
  padding-bottom: 18px;
  border-bottom: 1px solid #f0f0f0;
`;

const InfoChip = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  
  .emoji {
    font-size: 18px;
    line-height: 1;
    opacity: 0.7;
  }
  
  .content {
    .label {
      font-size: 11px;
      color: #999;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      margin-bottom: 2px;
    }
    
    .value {
      font-size: 15px;
      font-weight: 550;
      color: #222;
    }
  }
`;

const RoutePreview = styled.div`
  font-size: 14px;
  color: #555;
  margin-bottom: 18px;
  padding: 12px 16px;
  border-radius: 12px;
  line-height: 1.5;
  border-left: 3px solid #FF5E62;
`;

// Removed: HighlightsList, CabinTable, CabinRow, DescriptionText (no longer used)

const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1.5px solid #f0f0f0;
`;

const Price = styled.div`
  margin-bottom: 16px;
  
  .label {
    font-size: 12px;
    color: #999;
    margin-bottom: 4px;
  }
  
  .amount {
    font-size: 26px;
    font-weight: 700;
    color: #111;
    letter-spacing: -0.01em;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

// Восстановленные оригинальные стили кнопок
const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  color: #ffffff;
  background: linear-gradient(0.75turn, #FF9966, #FF5E62);
  box-shadow: 0px 5px 15px 0px rgba(255, 153, 102, 0.5);
  flex: 1;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 8px 20px 0px rgba(255, 153, 102, 0.6);
  }
`;

const SecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  color: #000000;
  background-color: transparent;
  border: 1px solid #000000;
  flex: 1;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const ResultsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 24px;
  
  .count {
    font-size: 16px;
    color: #666;
    font-weight: 450;
    
    strong {
      color: #111;
      font-weight: 650;
    }
  }
  
  .sort {
    select {
      padding: 10px 32px 10px 16px;
      border: 1.5px solid #e8e8e8;
      border-radius: 40px;
      font-size: 14px;
      background: white;
      color: #333;
      font-weight: 450;
      cursor: pointer;
      appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='%23666' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 16px center;
      
      &:focus {
        outline: none;
        border-color: #111;
      }
    }
  }
`;

const NoResults = styled.div`
  text-align: center;
  padding: 80px 20px;
  color: #666;
  background: white;
  border-radius: 24px;
  border: 1px solid #f0f0f0;
  
  .icon {
    font-size: 48px;
    margin-bottom: 24px;
    opacity: 0.5;
  }
  
  h3 {
    font-size: 22px;
    margin-bottom: 12px;
    color: #111;
    font-weight: 600;
  }
  
  p {
    font-size: 16px;
    color: #888;
  }
`;

const LoadingSpinner = styled.div`
  text-align: center;
  padding: 80px;
  font-size: 18px;
  color: #666;
  background: white;
  border-radius: 24px;
`;

const CruisesPage = () => {
  const navigate = useNavigate();
  const [cruises, setCruises] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isConsultPopupOpen, setIsConsultPopupOpen] = useState(false);
  const [selectedCruise, setSelectedCruise] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(6);
  
  // Search and filter state
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [priceMin, setPriceMin] = useState('');
  const [priceMax, setPriceMax] = useState('');
  const [durationMin, setDurationMin] = useState('');
  const [durationMax, setDurationMax] = useState('');
  const [shipFilter, setShipFilter] = useState('');
  const [sortBy, setSortBy] = useState('departure_date');

  useEffect(() => {
    fetchCruises();
  }, []);

  const fetchCruises = async () => {
    setLoading(true);
    try {
      // Add timeout to prevent infinite loading
      const fetchPromise = fetchWithAuthRefresh(async () => {
        return await supabase
          .from('cruises')
          .select('*')
          .eq('status', 'active')
          .order('departure_date', { ascending: true });
      });
      
      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error('Fetch timeout')), 10000)
      );
      
      const { data, error } = await Promise.race([fetchPromise, timeoutPromise]);

      if (error) throw error;
      setCruises(data || []);
    } catch (error) {
      console.error('Error fetching cruises:', error);
      // Set empty array on error to prevent infinite loading
      setCruises([]);
    } finally {
      // Always set loading to false
      setLoading(false);
    }
  };

  const uniqueShips = useMemo(() => {
    return [...new Set(cruises.map(c => c.ship_name).filter(Boolean))];
  }, [cruises]);

  const filteredCruises = useMemo(() => {
    let filtered = cruises.filter(cruise => {
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        const matchTitle = cruise.title?.toLowerCase().includes(term);
        const matchShip = cruise.ship_name?.toLowerCase().includes(term);
        const matchRoute = cruise.route?.toLowerCase().includes(term);
        if (!matchTitle && !matchShip && !matchRoute) return false;
      }

      if (dateFrom && cruise.departure_date) {
        if (new Date(cruise.departure_date) < new Date(dateFrom)) return false;
      }
      if (dateTo && cruise.departure_date) {
        if (new Date(cruise.departure_date) > new Date(dateTo)) return false;
      }

      if (priceMin && cruise.price_from) {
        if (cruise.price_from < Number(priceMin)) return false;
      }
      if (priceMax && cruise.price_from) {
        if (cruise.price_from > Number(priceMax)) return false;
      }

      if (durationMin && cruise.duration_days) {
        if (cruise.duration_days < Number(durationMin)) return false;
      }
      if (durationMax && cruise.duration_days) {
        if (cruise.duration_days > Number(durationMax)) return false;
      }

      if (shipFilter && cruise.ship_name !== shipFilter) return false;

      return true;
    });

    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'departure_date':
          return new Date(a.departure_date) - new Date(b.departure_date);
        case 'price_asc':
          return (a.price_from || 0) - (b.price_from || 0);
        case 'price_desc':
          return (b.price_from || 0) - (a.price_from || 0);
        case 'duration_desc':
          return (b.duration_days || 0) - (a.duration_days || 0);
        default:
          return 0;
      }
    });

    return filtered;
  }, [cruises, searchTerm, dateFrom, dateTo, priceMin, priceMax, durationMin, durationMax, shipFilter, sortBy]);

  const handleCardClick = (cruise) => {
    navigate(`/cruises/${cruise.slug}`);
  };

  const handleBookClick = (e, cruise) => {
    e.stopPropagation();
    setSelectedCruise(cruise);
    setIsConsultPopupOpen(true);
  };
  
  const formatFullDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const clearFilters = () => {
    setSearchTerm('');
    setDateFrom('');
    setDateTo('');
    setPriceMin('');
    setPriceMax('');
    setDurationMin('');
    setDurationMax('');
    setShipFilter('');
    setSortBy('departure_date');
  };

  const loadMore = () => {
    setVisibleCount(prev => prev + 6);
  };

  const displayedCruises = filteredCruises.slice(0, visibleCount);

  const hasActiveFilters = searchTerm || dateFrom || dateTo || priceMin || priceMax || durationMin || durationMax || shipFilter;
const getDefaultImage = (shipName) => {
  if (shipName?.includes('Spectrum')) {
    return 'https://nlkyksakfknxewmoqtqz.supabase.co/storage/v1/object/public/tour-images/cruise-images/24241.jpg';
  }
  if (shipName?.includes('Explora')) {
    return 'https://nlkyksakfknxewmoqtqz.supabase.co/storage/v1/object/public/tour-images/cruise-images/ec2dd97b3142e7a0d30517eb57998209.jpg';
  }
  return 'https://images.unsplash.com/photo-1548574505-5e239809ee19?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80';
};
  const removeFilter = (filterName) => {
    switch(filterName) {
      case 'search': setSearchTerm(''); break;
      case 'date': setDateFrom(''); setDateTo(''); break;
      case 'price': setPriceMin(''); setPriceMax(''); break;
      case 'duration': setDurationMin(''); setDurationMax(''); break;
      case 'ship': setShipFilter(''); break;
      default: break;
    }
  };

  if (loading) {
    return <LoadingSpinner>Загрузка...</LoadingSpinner>;
  }

  return (
    <Container>
      <Content>
        {/* Переработанный блок поиска и фильтров */}
        <SearchFilterSection>
          <SearchBar>
            <SearchInputWrapper>
              <SearchIcon src={searchIcon} alt="Поиск" />
              <SearchInput
                type="text"
                placeholder="Поиск по названию, кораблю или маршруту..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </SearchInputWrapper>
            <FilterToggle onClick={() => setIsFilterOpen(!isFilterOpen)}>
              <img src={filterIcon} alt="Фильтры" style={{ width: '18px', height: '18px' }} />
              Фильтры {hasActiveFilters && `(${filteredCruises.length})`}
            </FilterToggle>
          </SearchBar>

          <FilterPanel $isOpen={isFilterOpen}>
            <FilterGrid>
              <FilterGroup>
                <label>Дата от</label>
                <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
              </FilterGroup>

              <FilterGroup>
                <label>Дата до</label>
                <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
              </FilterGroup>

              <FilterGroup>
                <label>Цена от (₽)</label>
                <input type="number" placeholder="Мин. цена" value={priceMin} onChange={(e) => setPriceMin(e.target.value)} />
              </FilterGroup>

              <FilterGroup>
                <label>Цена до (₽)</label>
                <input type="number" placeholder="Макс. цена" value={priceMax} onChange={(e) => setPriceMax(e.target.value)} />
              </FilterGroup>

              <FilterGroup>
                <label>Дней от</label>
                <input type="number" placeholder="Мин. дней" value={durationMin} onChange={(e) => setDurationMin(e.target.value)} />
              </FilterGroup>

              <FilterGroup>
                <label>Дней до</label>
                <input type="number" placeholder="Макс. дней" value={durationMax} onChange={(e) => setDurationMax(e.target.value)} />
              </FilterGroup>

              <FilterGroup>
                <label>Корабль</label>
                <select value={shipFilter} onChange={(e) => setShipFilter(e.target.value)}>
                  <option value="">Все корабли</option>
                  {uniqueShips.map(ship => (
                    <option key={ship} value={ship}>{ship}</option>
                  ))}
                </select>
              </FilterGroup>
            </FilterGrid>

            <FilterActions>
              <ClearButton onClick={clearFilters}>
                ✕ Сбросить все фильтры
              </ClearButton>
            </FilterActions>
          </FilterPanel>

          {/* Активные фильтры в виде тегов */}
          {hasActiveFilters && (
            <ActiveFilters style={{ marginTop: isFilterOpen ? '20px' : '16px' }}>
              {searchTerm && (
                <FilterTag>
                  Поиск: {searchTerm}
                  <button onClick={() => removeFilter('search')}>✕</button>
                </FilterTag>
              )}
              {(dateFrom || dateTo) && (
                <FilterTag>
                  Даты: {dateFrom ? formatFullDate(dateFrom) : '...'} — {dateTo ? formatFullDate(dateTo) : '...'}
                  <button onClick={() => removeFilter('date')}>✕</button>
                </FilterTag>
              )}
              {(priceMin || priceMax) && (
                <FilterTag>
                  Цена: {priceMin || '0'} — {priceMax || '∞'} ₽
                  <button onClick={() => removeFilter('price')}>✕</button>
                </FilterTag>
              )}
              {(durationMin || durationMax) && (
                <FilterTag>
                  Длительность: {durationMin || '0'} — {durationMax || '∞'} дн.
                  <button onClick={() => removeFilter('duration')}>✕</button>
                </FilterTag>
              )}
              {shipFilter && (
                <FilterTag>
                  Корабль: {shipFilter}
                  <button onClick={() => removeFilter('ship')}>✕</button>
                </FilterTag>
              )}
            </ActiveFilters>
          )}
        </SearchFilterSection>

        {/* Заголовок с результатами и сортировкой */}
        <ResultsHeader>
          <div className="count">
            Найдено <strong>{filteredCruises.length}</strong> {filteredCruises.length === 1 ? 'круиз' : filteredCruises.length < 5 ? 'круиза' : 'круизов'}
          </div>
          <div className="sort">
            <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              <option value="departure_date">По дате (ближайшие)</option>
              <option value="price_asc">По цене (возрастание)</option>
              <option value="price_desc">По цене (убывание)</option>
              <option value="duration_desc">По длительности</option>
            </select>
          </div>
        </ResultsHeader>

        {/* Карточки с одной кнопкой для всех деталей */}
        {filteredCruises.length > 0 ? (
          <ToursGrid>
            {displayedCruises.map((cruise) => {
              return (
                <TourCard key={cruise.id}>
                  <ImageWrapper onClick={() => handleCardClick(cruise)}>
  <img 
    src={cruise.image_url || getDefaultImage(cruise.ship_name)} 
    alt={cruise.title}
    onError={(e) => {
      e.target.onerror = null; // Предотвращает бесконечный цикл
      e.target.src = getDefaultImage(cruise.ship_name);
    }}
  />
</ImageWrapper>

                  <CardContent>
                    <CardHeader>
                      <CardTitle onClick={() => handleCardClick(cruise)}>{cruise.title}</CardTitle>
                      {cruise.subtitle && <CardSubtitle>{cruise.subtitle}</CardSubtitle>}
                    </CardHeader>

                    <InfoStrip>
                      <InfoChip>
                        <span className="emoji">
                          <img src={calendarIcon} alt="Дата" style={{ width: '20px', height: '20px' }} />
                        </span>
                        <div className="content">
                          <div className="label">Отправление</div>
                          <div className="value">{formatFullDate(cruise.departure_date)}</div>
                        </div>
                      </InfoChip>
                      <InfoChip>
                        <span className="emoji">
                          <img src={clockIcon} alt="Длительность" style={{ width: '20px', height: '20px' }} />
                        </span>
                        <div className="content">
                          <div className="label">Длительность</div>
                          <div className="value">{cruise.duration_days} дн. / {cruise.duration_nights} н.</div>
                        </div>
                      </InfoChip>
                      <InfoChip>
                        <span className="emoji">
                          <img src={shipIcon} alt="Корабль" style={{ width: '20px', height: '20px' }} />
                        </span>
                        <div className="content">
                          <div className="label">Корабль</div>
                          <div className="value">{cruise.ship_name}</div>
                        </div>
                      </InfoChip>
                    </InfoStrip>

                    {cruise.route && (
                      <RoutePreview>
                        {cruise.route}
                      </RoutePreview>
                    )}

                    <PriceSection>
                      <Price>
                        <div className="label">Стоимость от</div>
                        <div className="amount">{cruise.price_from?.toLocaleString('ru-RU')} ₽</div>
                      </Price>
                      <ButtonGroup>
                        <SecondaryButton onClick={() => handleCardClick(cruise)}>
                          Подробнее
                        </SecondaryButton>
                        <PrimaryButton onClick={(e) => handleBookClick(e, cruise)}>
                          Забронировать
                        </PrimaryButton>
                      </ButtonGroup>
                    </PriceSection>
                  </CardContent>
                </TourCard>
              );
            })}
          </ToursGrid>
        ) : (
          <NoResults>
            <div className="icon">
              <img src={searchIcon} alt="Поиск" style={{ width: '48px', height: '48px', opacity: 0.3 }} />
            </div>
            <h3>Круизы не найдены</h3>
            <p>Попробуйте изменить параметры поиска или сбросить фильтры</p>
            <ClearButton onClick={clearFilters} style={{ marginTop: '24px', background: '#111', color: 'white', padding: '12px 24px' }}>
              Сбросить все фильтры
            </ClearButton>
          </NoResults>
        )}

        {/* Load More Button */}
        {visibleCount < filteredCruises.length && (
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <button
              onClick={loadMore}
              style={{
                padding: '15px 40px',
                backgroundColor: '#FF5E62',
                color: 'white',
                border: 'none',
                borderRadius: '40px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                fontFamily: 'Geologica, Arial, sans-serif',
                boxShadow: '0 4px 12px rgba(255, 94, 98, 0.3)'
              }}
            >
              Загрузить еще ({filteredCruises.length - visibleCount} круизов)
            </button>
          </div>
        )}
      </Content>

      <ChinaConsultPopup 
        isOpen={isConsultPopupOpen} 
        onClose={() => setIsConsultPopupOpen(false)} 
        selectedTour={selectedCruise}
      />
    </Container>
  );
};

export default CruisesPage;